<template>
  <div class="row m-0">
    <div class="col-12 p-0">
      <ManageSubscription />
    </div>
  </div>
</template>

<script>
import ManageSubscription from '../components/Profile/ManageSubscription.vue'

export default {
  name: 'Subscription',
  components: {
    ManageSubscription
  }
}
</script>
